import {Component, OnInit} from '@angular/core';
import {BsModalRef, BsModalService} from "ngx-bootstrap/modal";
import {InsightsHelpModalComponent} from "../insights-help-modal/insights-help-modal.component";

@Component({
  selector: 'app-insights-help',
  templateUrl: './insights-help.component.pug',
  styleUrls: ['./insights-help.component.scss'],
  standalone: false
})
export class InsightsHelpComponent implements OnInit {

  bsModalRef!: BsModalRef;
  constructor(private modalService: BsModalService,) { }

  ngOnInit(): void {
  }

  showHelp(): void {
    this.bsModalRef = this.modalService.show(InsightsHelpModalComponent, {
      class: 'modal-dialog-centered modal-lg'
    });
  }
}
